import { NonWorkingHours, TimetableProps, WorkingHours } from '@/interfaces/models/timetable';

export default class Timetable {
  public workingHours: WorkingHours;
  public nonWorkingHours: NonWorkingHours;

  public constructor(timetableProps: TimetableProps) {
    this.workingHours = timetableProps.workingHours;
    this.nonWorkingHours = timetableProps.nonWorkingHours;
  }

  get workingFromHour() {
    return this.workingHours[0] / 3600;
  }

  get workingToHour() {
    return this.workingHours[1] / 3600;
  }

  get isFullDayWorking() {
    return this.workingHours[1] - this.workingHours[0] - this.breakDuration === 86400;
  }

  get breakDuration() {
    return this.nonWorkingHours.reduce((duration: number, nonWorkingHours: any) => {
      if (nonWorkingHours !== null) {
        duration += nonWorkingHours[1] - nonWorkingHours[0];
      }

      return duration;
    }, 0);
  }

  getTimeToOpen(seconds: number) {
    if (this.isCloseUntilTomorrow(seconds)) {
      return 86400 - seconds;
    }

    const breakRange = this.getBreakBySeconds(seconds);

    if (breakRange) {
      return breakRange[1] - seconds;
    }

    return 0;
  }

  // Todo: use high order functions for find
  getBreakBySeconds(seconds: number) {
    if (seconds < this.workingHours[0]) {
      return [ 0, this.workingHours[0] ];
    } else if (seconds > this.workingHours[1]) {
      return [ this.workingHours[1], this.workingHours[1] + this.workingHours[0] ];
    }

    return this.nonWorkingHours.find((nonWorkingHours: number[] | null) => {
      return nonWorkingHours !== null
        && nonWorkingHours[0] <= seconds
        && seconds < nonWorkingHours[1];
    });
  }

  private isCloseUntilTomorrow(seconds: number) {
    return this.workingHours[1] < seconds;
  }

  isWorkingHour(hour: number) {
    const hourInSeconds = hour * 3600;

    return this.isWorkingTime(hourInSeconds);
  }

  isWorkingTime(seconds: number) {
    return this.isWorkingHoursContain(seconds) && !this.isNonWorkingHoursContain(seconds);
  }

  isWorkingHoursContain(seconds: number) {
    return this.workingHours[0] <= seconds && seconds < this.workingHours[1];
  }

  isNonWorkingHoursContain(seconds: number) {
    return this.nonWorkingHours.some((nonWorkingHours: number[] | null) => {
      if (nonWorkingHours !== null) {
        return nonWorkingHours[0] <= seconds && seconds < nonWorkingHours[1];
      }

      return false;
    });
  }
}
